define('LocationShippingTimes.MyAccount.EntryPoint', [
  'Backbone',
  'ZipCodeSession'
], function KodellaLocationShippingTimesMyAccount(Backbone, ZipCodeSession) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      var layout = container.getComponent('Layout');
      var regex = /^request-a-quote-confirmation/;

      layout.on('beforeShowContent', function onBeforeShowContent() {
        if (regex.test(Backbone.history.fragment)) {
          ZipCodeSession.clearZipCode();
        }
      });
    }
  };
});
